export const SAVE_PRECHAT = 'SAVE_PRECHAT';
export const RESET_PRECHAT = 'RESET_PRECHAT';